import { Decimal, type D, ZERO } from './decimal'
import { GLOBAL } from '../config/global'

export type OperatorSymbol = '+' | '-' | '×' | '÷' | '^' | '='

export interface OperatorDef {
  symbol: OperatorSymbol
  name: string
  edition: number
  distinctLetters: number
}

export const OPERATORS: OperatorDef[] = [
  { symbol: '+', name: 'Addition', edition: 1, distinctLetters: 5 },
  { symbol: '-', name: 'Subtraction', edition: 1, distinctLetters: 9 },
  { symbol: '×', name: 'Multiplication', edition: 1, distinctLetters: 14 },
  { symbol: '÷', name: 'Division', edition: 2, distinctLetters: 18 },
  { symbol: '^', name: 'Exponentiation', edition: 2, distinctLetters: 22 },
  { symbol: '=', name: 'Equation', edition: 3, distinctLetters: 26 },
]

export function isOperatorUnlocked(
  op: OperatorDef,
  edition: number,
  distinct: number,
): boolean {
  return edition >= op.edition && distinct >= op.distinctLetters
}

// Board entry: either a raw letter or an operator result
export interface BoardEntry {
  id: number
  letterId?: number    // raw letter
  label?: string       // display label (e.g. "E+T")
  output: D            // computed output
}

// Compute the output of a single letter at its current level
export function letterEntryOutput(
  baseOutput: number,
  level: number,
  capital: boolean,
): D {
  if (level <= 0) return ZERO
  let out = new Decimal(baseOutput)
  // Apply level scaling: baseOutput * 1.1^(level-1)
  for (let i = 1; i < level; i++) out = out.mul(GLOBAL.levelOutputMultiplier)
  if (capital) out = out.mul(GLOBAL.capOutputMultiplier)
  return out
}

// Serif typeface bonus multiplier
export function serifMultiplier(typeface: Record<string, number>): number {
  return 1 + (typeface.serif ?? 0) * GLOBAL.serifBonusPerTier
}

// Bold typeface burst bonus
export function boldBurstMultiplier(typeface: Record<string, number>): number {
  return 1 + (typeface.bold ?? 0) * GLOBAL.boldBurstPerTier
}
